"use client";

import { IconFlame } from "@tabler/icons-react";
import { CAPACITY_BANNER_OFFSET, SiteNoticeBanner } from "@/components/site-notice-banner";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { useAuth } from "@/lib/auth";
import { capacityBlockedDetail } from "@/lib/capacity-status-detail";
import { cn } from "@/lib/utils";

export { CAPACITY_BANNER_OFFSET };

type Variant = "global" | "inline";

export const CapacityNoticeBanner = ({ variant = "global", className }: { variant?: Variant; className?: string }) => {
  const { capacityStatus } = useAuth();

  if (!capacityStatus || capacityStatus.state === "granted") {
    return null;
  }

  const state = capacityStatus.state;
  const title = state === "blocked_global" ? "Radium is at capacity" : "You are on the waitlist";
  const detail = capacityBlockedDetail(capacityStatus);

  if (variant === "inline") {
    return (
      <Alert variant="warning" className={cn("mb-4", className)}>
        <IconFlame aria-hidden />
        <AlertDescription className="text-foreground/90 col-start-2 line-clamp-2 md:line-clamp-1 md:truncate">
          <span className="font-medium">{title}</span>
          <span className="text-foreground/85"> · {detail}</span>
        </AlertDescription>
      </Alert>
    );
  }

  return <SiteNoticeBanner tone="amber" title={title} detail={detail} className={className} />;
};
